import axios from 'axios';

const baseUrl =
  process.env.REACT_APP_QCX_API_BASE_URL! + '/followup/report/aguardando-desembaraco';

export const generateAguardandoDesembaracoReport = async (
  token: string,
  unidadeId: string,
  tenantIds: string[],
  clientIds: string[],
  processIds: string[],
  viaId: string | null,
  canal: string | null,
  startISO: string,
  endISO: string,
): Promise<string | null> => {
  const p = new URLSearchParams();
  p.set('tenantId', tenantIds.join(','));
  if (clientIds.length)  p.set('clientesId',  clientIds.join(','));
  if (processIds.length) p.set('processosId', processIds.join(','));
  if (viaId)             p.set('viaId',       viaId);
  if (canal)             p.set('canal',       canal);
  p.set('insertionDateRange', `${startISO};${endISO}`);

  try {
    const r = await axios.get(`${baseUrl}?${p.toString()}`, {
      headers: { Authorization: `Bearer ${token}`, quickcomexTenant: unidadeId },
      responseType: 'blob', validateStatus: () => true,
    });

    if (r.status === 200) {
      const f = new File([r.data], 'aguardando-desembaraco.xlsx',
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(f);
      const a = document.createElement('a'); a.href = url; a.download = f.name; a.click();
      return null;
    }
    return await r.data.text();
  } catch { return 'Erro ao gerar o relatório.'; }
};
